import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';

class DocDateTimeRangeEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 id="dtr" className="heading-1">DateTime_Range</h3>
                    <div className="description">The pattern for datetime ranges attempts to extract various written forms of a 
                        range in dates. The start and end points consist of minimum and maximum values for the components of 
                        a date with the exception of the year being unknown.
                    </div>

                    <h4 className="heading-3">Range in Years</h4>
                    <div className="example-content">
                        <span className="line">1970&apos;s </span>
                        <span className="line">1997-08</span>
                        <span className="line">1995 through 2011</span>
                    </div>

                    <h4 className="heading-3">Range in Months </h4>
                    <div className="example-content">
                        <span className="line">February - March 2014</span>
                        <span className="line">August through February</span>
                        <span className="line">Nov - Dec</span>
                    </div>

                    <h4 className="heading-3">Other Ranges</h4>
                    <div className="example-content">
                        <span className="line">November</span>
                        <span className="line">December 2013</span>
                        <span className="line">July 2007 - March 2009</span>
                        <span className="line">April 15, 2011 to May 7, 2012 </span>
                        <span className="line">Oct 1973</span>
                    </div>

                    <h4 className="heading-3">Non English</h4>
                    <div className="example-content">
                        <span className="line">maart</span>
                        <span className="line">Março</span>
                        <span className="line">Marzo</span>
                    </div>

                    <h4 className="heading-3">Relative</h4>
                    <div className="example-content">
                        <span className="line">this Wednesday</span>
                        <span className="line">last February</span>
                        <span className="line">yesterday, today, tomorrow</span>
                    </div>
                    <br/>
                    <div className="description">Relative is only applicable if publishDate is provided in the request.
                    </div>

                    <br/>

                    <div className="description">The components of the start and end dates are standardized 
                        to a locale neutral, ISO8601 formatted value and embedded in JSON as attributes. An extracted datetime 
                        range will be represented by the following attributes: 
                    </div>

                    <table className="table-wrapper">
                        <thead className="table-header">
                        <tr>
                            <th>Attribute </th>
                            <th>Meaning </th>
                            <th>Type </th>
                            <th>Constraints </th>
                            <th>Notes </th>
                        </tr>
                        </thead>
                        <tbody className="table-body">
                        <tr>
                            <td className="attribute">startDate</td>
                            <td className="meaning">Embedded JSON of the start date&apos;s components</td>
                            <td className="type">JSON Object</td>
                            <td className="constraints">Mandatory</td>
                            <td className="notes">The embedded components are those equal to a DATE entity</td>
                        </tr>
                        <tr>
                            <td className="attribute">endDate</td>
                            <td className="meaning">Embedded JSON of the end date&apos;s components</td>
                            <td className="type">JSON Object</td>
                            <td className="constraints">Mandatory</td>
                            <td className="notes">The embedded components are those equal to a DATE entity</td>
                        </tr>
                        <tr>
                            <td className="attribute">period</td>
                            <td className="meaning">Duration of field values</td>
                            <td className="type">String</td>
                            <td className="constraints">Mandatory</td>
                            <td className="notes">
                                Utilizes the jodatime Period object
                                Expressed as String that is easy to parse
                                e.g. P9Y11M4W2D
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">estimated</td>
                            <td className="meaning">A boolean flag indicating if the datetime value is estimated</td>
                            <td className="type">Boolean</td>
                            <td className="constraints">Optional</td>
                            <td className="notes"><i>true</i> if the datetime value is estimated using <i>publishDate</i>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <h4 className="heading-2">Examples</h4>

                    <div className="example-content">Specific Date Range: June through July 2006</div>
                    <HttpRunner example = "dateRange1" 
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_DATETIMERANGE1) : null}
                    />
                    <br/>
                    <div className="example-content">General Date Range: 1980s</div>
                    <HttpRunner example = "dateRange2" 
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_DATETIMERANGE2) : null}
                    />
                    <br/>
                    <div className="example-content">Relative: The results are from last March</div>
                    <HttpRunner example = "dateRange3" 
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_DATETIMERANGE3) : null}
                    />
                </div>
            </div>
        );
    }
}

export default DocDateTimeRangeEntity;